export default class DirectScript {
  constructor() {
    this.init();
  }

  init() {
    this.json = '';
  }
}
